/**
* @file 运营中心-平台管理
* */
<template>
  <div id="settingFrame">
    <el-tabs type="card" v-model="tabAction">
      <el-tab-pane v-for="item in tabs" :key="item.name" :name="item.name">
        <template slot="label">
          <i v-if="item.icon" :class="item.icon" style="margin-right: 4px"></i>{{ item.label }}
        </template>
      </el-tab-pane>
    </el-tabs>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: "settingFrame",
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     vm.tabAction = to.path
  //   })
  // },
  data() {
    return {
      // tabs列表
      tabs: [],
      tabAction: null,
    };
  },
  computed: {
    ...mapGetters({'buttonsGetter': 'buttonsGetter'})
  },
  watch: {
    tabAction() {
      this.$router.push(this.tabAction);
    },
    $route: {
      handler(val) {

        if (val.path == '/activity') {
          let tabs = [];
          if (this.menuPreFn(92)) tabs.push({label: "司机拉新", name: "/invitation", icon: 'el-icon-share'});
          if (this.menuPreFn(96)) tabs.push({label: "首单奖励", name: "/chargeOrder", icon: 'el-icon-trophy'});
          this.tabs = tabs;
          this.tabAction = this.tabAction ?this.tabAction : tabs[0].name
          this.$router.push(this.tabAction);
          return
        }
        this.tabAction = val.path;
      },
      immediate: true,
      deep: true,
    },
  },
  async created() {
    this.mixinOrganizations();
    let tabs = [];
    setTimeout(() => {

      if (this.menuPreFn(92)) tabs.push({label: "司机拉新", name: "/invitation", icon: 'el-icon-share'});
      if (this.menuPreFn(96)) tabs.push({label: "首单奖励", name: "/chargeOrder", icon: 'el-icon-trophy'});

      this.tabs = tabs;
      this.tabAction = this.tabAction && this.tabAction != '/settingFrame' ? this.tabAction : tabs[0].name;
    }, Object.values(this.buttonsGetter ? this.buttonsGetter : {}).length > 0 ? 0 : 1500);
  },
};
</script>

<style lang="less">
#settingFrame {
  height: 100%;

  .content {
    height: calc(100% - 40px);

    & > div {
      height: 100%;
    }
  }
}
</style>
